module.exports = __webpack_public_path__ + "a660bfb2061822c0e98b9e01302b4fdd.jpg";